import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth, primaryShell } from "@/hooks/use-auth";
import { PortalShell } from "@/components/portal-shell";
import { useImpersonation } from "@/hooks/use-impersonation";
import { ExperienceModeGate } from "@/components/experience-mode-gate";

export const Route = createFileRoute("/_authenticated/portal")({ component: PortalLayout });

function PortalLayout() {
  const { roles, loading } = useAuth();
  const imp = useImpersonation();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (imp.isLoading) return;
    // Operators viewing as a customer are allowed to stay on the portal.
    if (imp.active) return;
    const shell = primaryShell(roles);
    if (shell === "app") navigate({ to: "/app/operations/desk" });
    if (shell === "none") navigate({ to: "/no-access" });
  }, [roles, loading, imp.active, imp.isLoading, navigate]);
  // Operator impersonation bypasses the mode gate: operators previewing as a
  // customer should always see the Customer Workspace regardless of their own
  // resolved modes.
  return (
    <PortalShell>
      {imp.active ? (
        <Outlet />
      ) : (
        <ExperienceModeGate mode="customer_portal">
          <Outlet />
        </ExperienceModeGate>
      )}
    </PortalShell>
  );
}